var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from 'next-i18next';
import Modal from '@spa/shared/components/Modal';
import PaymentSummary from '@spa/shared/components/PaymentSummary';
import { useMedia } from '@spa/shared/hooks';
import { GlobalModalStyle } from './styles';
var PaymentSummaryModal = function PaymentSummaryModal(_ref) {
  var accommodationOffer = _ref.accommodationOffer,
    property = _ref.property,
    priceDetails = _ref.priceDetails,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useMedia = useMedia(),
    is = _useMedia.is;
  return __jsx(Modal, {
    onClose: onClose,
    title: t('Paymment summary'),
    maxHeight: !is.mobile ? '85vh' : null,
    width: !is.mobile ? '50%' : null,
    className: "payment-summary"
  }, __jsx(GlobalModalStyle, null), __jsx(PaymentSummary, {
    accommodationOffer: accommodationOffer,
    property: property,
    priceDetails: priceDetails
  }));
};
export default PaymentSummaryModal;